<template>
  <div id="editUser"  >
      <div class="modal-dialog modal-dialog-centered" role="document">
         <div class="modal-content">
            <div class="modal-header">
            <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :on-cancel="onCancel"
                :is-full-page="fullPage"></loading>
               <flash-message class="myCustomClass"></flash-message>
               <h5 class="modal-title" id="exampleModalLabel">Edit User</h5>
               <button type="button" class="close" id="edituserpopupclose"  @click="$emit('close')" data-dismiss="modal" aria-label="Close">
               <i class="material-icons">close</i>
               </button>
            </div>
            <form action="#" @keyup.enter="editUser()">
               <div class="modal-body">
               <p style="color:red;text-align:center">{{ errorMessage }}</p>
                  <p v-if="errors.length">
                <!-- <ul>
                  <li style='color:red' v-for="error in errors">{{ error }}</li>
                </ul> -->
                <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
              </p> 
                  <div class="form-group">
                     <input type="text" ref="firstname" class="form-control" placeholder="Firstname" id="firstname" name="firstname" v-model="userDetails.firstname" />
                  </div>
                   <div class="form-group">
                     <input type="text" ref="lastname" class="form-control" placeholder="Lastname" id="lastname" name="lastname" v-model="userDetails.lastname" />
                  </div>
                  <div class="form-group">
                     <input type="text" ref="username" class="form-control" placeholder="User Name" id="username" name="username" v-model="userDetails.username" />
                     <input type="hidden" class="form-control" placeholder="User Name" id="uid" name="uid" v-model="userDetails.uid" />
                  </div>
                  <div class="form-group">
                     <input type="text" ref="email" class="form-control" placeholder="Email" id="email" name="email" v-model="userDetails.email" />
                  </div>
                  <div class="form-group">
                     <input type="password" ref="password" class="form-control" name="password" v-model="password" id="password" placeholder="Password" />
                  </div>
                  <!-- <div class="form-group">
                     <input type="password" ref="cnfpassword" class="form-control" name="cnfpassword" v-model="cnfpassword" id="cnfpassword" placeholder="Confirm Password" />
                  </div> -->
                  
               </div>
               <div class="modal-footer">
                  <!-- <button type="button" class="btn btn-primary">Add</button> -->
                  <input type="button" class="btn btn-primary" value="Edit" v-on:click="editUser()" />
                  <button type="button" class="btn btn-secondary" @click="$emit('close')" >Cancel</button>
               </div>
            </form>
         </div>
      </div>
   </div>
</template>
<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
require('vue-flash-message/dist/vue-flash-message.min.css')
export default {
  name: 'EditUserModal',
  props: ['userDetails'],
  components: {
    Loading
  },
  data () {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      users: [],
      errors: [],
      password: '',
      cnfpassword: '',
      input: {
        email: '',
        firstname: '',
        lastname: '',
        username: '',
        userrole: '',
        password: '',
        cnfpassword: ''
      },
      errormessage: ''
    }
  },
  methods: {
    editUser () {
      this.errors = []
      var jwttoken = localStorage.getItem('jwt')
      var firstname = this.userDetails.firstname
      var lastname = this.userDetails.lastname
      var email = this.userDetails.email
      var username = this.userDetails.username
      var password = this.password
      var cnfpassword = this.cnfpassword
      var uid = this.userDetails.uid
      if (firstname === '') {
        this.errors.push('Name is Required')
        this.$refs.firstname.focus()
      } else if (firstname.length < 3) {
        this.errors.push('Name must be 3 characters long')
        this.$refs.firstname.focus()
      } else if (username === '') {
        this.errors.push('Username is Required')
        this.$refs.username.focus()
      } else if (username < 3) {
        this.errors.push('Username must be 3 characters long')
        this.$refs.username.focus()
      } else if (email === '') {
        this.errors.push('Email is Required')
        this.$refs.email.focus()
      } else if (!this.emailValidator.validate(email)) {
        this.errors.push('Invalid contact Email')
        this.$refs.email.focus()
      } else {
        this.isLoading = true
        axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/editUser',
          {
            firstname: firstname,
            lastname: lastname,
            email: email,
            username: username,
            password: password,
            confirm_password: cnfpassword,
            user_id: uid
          }, {
            headers: {
              'x-access-token': jwttoken
            }})
          .then(response => {
            this.isLoading = false
            this.$eventBus.$emit('listUser', 'User is Updated successfully');
            this.$emit('close')
           })
            .catch((error) => {
              this.$eventBus.$emit('listUser', '','User could not be Updated');
              this.$emit('close')
              this.errorMessage = error.response.data.errors
              this.isLoading = false
            }) 
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/EditUserModal.vue